module.exports = __webpack_public_path__ + "b84fd08faf14c25c6a62ead56267d803.jpg";